import { format } from "rut.js";
import { columns } from "../../../dtos/columns";
import { EliminarParticipante, Participante } from "../models/participantes";
import AccionesParticipantes from "../components/participantes/accionesParticipantes";
import Conversiones from "../../../utils/conversiones";
import { numericFormatter } from "react-number-format";
import { enumTipoParticipanteConValores } from "../../../utils/enums";
import { Mandatario } from "../models/mandatario";
import { Conyuge } from "../models/conyuge";
import { Deudor } from "../models/deudor";
import { Codeudor } from "../models/codeudor";
import { DeudorJuridico } from "../models/deudorJuridico";

export function useColumns(setRolParticipanteSeleccionado: (value: enumTipoParticipanteConValores) => void,
    setDataMandatario: (value: Mandatario) => void,
    setDataConyuge: (value: Conyuge) => void,
    setDataDeudor: (value: Deudor) => void,
    setDataDeudorJuridico: (value: DeudorJuridico) => void,
    setDataCodeudor: (value: Codeudor) => void,
    setShowParticipantes: (value: boolean) => void,
    setModalConfirmacion: (value: React.SetStateAction<{
        show: boolean;
        title: string;
        message: string;
        metodo: () => void;
    }>) => void,
    handleDelete: (dataDelete: EliminarParticipante) => Promise<void>,
    isComplementario?: boolean,
    isDesactivado?: boolean,
    esVigente?: boolean,
) {
    const COLUMNS: columns<Participante>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            sortable: false,
            wrap: true,
            export: false,
            cell: (row) => <AccionesParticipantes
                participante={row}
                setRolParticipanteSeleccionado={setRolParticipanteSeleccionado}
                setDataMandatario={setDataMandatario}
                setDataConyuge={setDataConyuge}
                setDataDeudor={setDataDeudor}
                setDataDeudorJuridico={setDataDeudorJuridico}
                setDataCodeudor={setDataCodeudor}
                setShowParticipantes={setShowParticipantes}
                setModalConfirmacion={setModalConfirmacion}
                handleDelete={handleDelete}
                isComplementario={isComplementario}
                isDesactivado={isDesactivado} 
                esVigente={esVigente!}
                />,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Tipo participante',
            selector: (row) => row.tipoParticipante,
            sortable: true,
            sortField: 'tipoParticipante',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'RUT',
            selector: (row) => format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Nombre',
            selector: (row) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true,
            left: true,
        },
        {
            name: 'Cónyuge',
            selector: (row) => row.conyuge,
            sortable: true,
            sortField: 'conyuge',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Fecha nacimiento',
            selector: (row) => Conversiones.fechaCortaFormat(row.fechaNacimiento),
            sortable: true,
            sortField: 'fechaNacimiento',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Estado civil',
            selector: (row) => row.estadoCivil,
            sortable: true,
            sortField: 'estadoCivil',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Porcentaje dominio',
            selector: (row) => row.porcentajeDominio,
            cell: (row) => numericFormatter(row.porcentajeDominio.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'porcentajeDominio',
            wrap: true,
            export: true,
            center: true,
        },
    ];

    return { COLUMNS };
}